import { WarehouseLayoutSchema } from "@redotech/redo-model/wms/schema/warehouse";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getWarehouseLayout = {
  name: "getWarehouseLayout" as const,
  input: z.object({ layoutId: zExt.objectId() }),
  output: z.union([z.object({ layout: WarehouseLayoutSchema })]),
};
